import moment from "moment/moment";
import { getDateFormat } from "./time";

export function formatRecurrenceLabel(recurring, date, recurrenceLabel) {
  if (recurring) {
    const dayOfWeek = moment(date).format("dddd");
    const dayIndexOfMonth = moment(date).format("DD");
    return recurrenceLabel ? recurrenceLabel.replace('{0}', dayOfWeek).replace('{1}', dayIndexOfMonth) :
      'Every ' + dayOfWeek;
  }
  return moment(date).format(getDateFormat('weekdayDateDisplayFormat'));
}

export function formatRecurrenceLabelWithStart(recurring, date, recurrenceLabel) {
  return formatRecurrenceLabel(recurring, date, recurrenceLabel) +
    (recurring ? ', beginning ' + moment(date).format("MM/DD") : '');
}

export function timeRange(startDate, duration) {
  const startTime = moment(startDate).format(getDateFormat('timeDisplayFormat'));
  const endTime = moment(startDate).add(duration, 'minutes').format(getDateFormat('timeDisplayFormat'));
  return `${startTime} – ${endTime}`;
}

export function dateRange(duration, startDate, recurrenceLabel, recurring) {
  return recurring ? formatRecurrenceLabel(recurring, startDate, recurrenceLabel)
    + ', ' + timeRange(startDate, duration) : moment(startDate).format(getDateFormat('weekdayDateDisplayFormat')) + "\n" + timeRange(startDate, duration);
}
